import { DOCUMENT } from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { TranslateService } from '@ngx-translate/core';
import { EmptyPlugin } from './plugin/empty.plugin';
import { CoreLoader } from './services/core-loader.service';
import { CoreServiceModule } from './services/core-service.module';

@NgModule({
  imports: [RouterModule, SharedModule, CoreServiceModule, BrowserAnimationsModule],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: (translate: TranslateService, empty: EmptyPlugin, document: Document) => {
        const language = translate.getCurrentLang() || empty.language;
        document.documentElement.lang = language;
        return language;
      },
      deps: [TranslateService, EmptyPlugin, DOCUMENT],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (core: CoreLoader) => () => core.loader().catch(() => core.default()),
      deps: [CoreLoader],
      multi: true,
    },
  ],
  exports: [RouterModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import CoreModule in the AppModule only.');
    }
  }
}
